import { lazy } from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

export const InviteUsers = lazy(() => import("@mediaspace-react-components/features/invite-users"));

export const render = getStandaloneComponentRenderer(InviteUsers);
